import React, { FC } from 'react'

import { IconFallDetectionProps } from './IconFallDetection.types'
import * as Styled from './styles/IconFallDetection.style'

import { nonThemeableRules } from '../../ruleSet'

const IconFallDetection: FC<IconFallDetectionProps> = ({
  size = nonThemeableRules.defaultSize as number as IconFallDetectionProps['size'],
  isResponsive = false,
}: IconFallDetectionProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M38.25 11.09a4.18 4.18 0 1 1-4.18-4.18h4.18v4.18Z' stroke='#EA1A1A' strokeLinecap='round' strokeWidth='2' />
        <path
          d='M17.48 40.958a2.709 2.709 0 0 1-1.198-.283 2.75 2.75 0 0 1-1.27-3.425l2.393-6.218a2.679 2.679 0 0 1 1.55-1.54l2.018-.75-3.19-1.127-4.706 2.885a2.673 2.673 0 1 1-2.764-4.575L16.1 22.38a2.688 2.688 0 0 1 2.272-.225l4.34 1.532 1.888-4a.11.11 0 0 0-.04-.15l-3.37-1.83a2.355 2.355 0 0 1-1.205-1.764l-.808-6.283a2.355 2.355 0 0 1 2.033-2.633c.1-.015.201-.024.302-.027a2.353 2.353 0 0 1 2.328 2.05l.63 4.9a.333.333 0 0 0 .183.25l8.512 3.867a2 2 0 0 1 .767.543l4.438 4.89a2.362 2.362 0 0 1 .543 2.233l-1.693 6.044c-.282 1-.883 2-1.932 2a2.349 2.349 0 0 1-2.263-2.985l1.25-4.48a.542.542 0 0 0-.122-.5l-1.58-1.69-2.866 5.905a2.672 2.672 0 0 1-1.614 1.733l-5.93 2.25a.501.501 0 0 0-.28.28l-1.908 4.96a2.687 2.687 0 0 1-2.495 1.708Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconFallDetection
